export const CASH_OUT_DAYS_LIMIT = 60;
export const ONE_DAY_IN_MILLIS = 24 * 60 * 60 * 1000;

export const DOCUMENT_REQUEST_STATUS_FULFILLED = 'fulfilled';

export const FINANCE_SETTINGS = 'finance-settings';
export const BANK_ACCOUNTS = 'bank-accounts';
export const ORGANIZATIONS = 'organizations';
export const TAXPAYER_INFO = 'taxpayer-info';

export const LOCALLY_STORED_TAXPAYER_REQUEST_STATUS_KEY =
    'locally_stored_taxpayer_request_status';
export const FINANCE_NOTIFICATION_MODAL_SEEN =
    'finance_notification_modal_seen';
